module.exports = __webpack_public_path__ + "static/media/lingmingshan_mobile.8307abe4.png";